import { useDispatch } from "react-redux";

import { setSection } from "../../../assignmentSlice";

import { typeInfo } from "../../../../../constants/typeInfo";

import UserInputBar from "../../widgets/UserInputBar";

const SubjectiveExamPage = ({
  currentPage,
  userInput,
  setUserInput,
  handleSubmit,
}) => {
  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        // [사이즈 수술] 75vw 고정이 공용틀 안에서 어긋나 좌우 잘림 —
        // 전폭 + 640 상한 + border-box로 고정. 톤·로직 무변경.
        width: "100%",
        maxWidth: "640px",
        margin: "0 auto",
        boxSizing: "border-box",
        padding: Math.min(window.innerWidth, window.screen.width) <= 768 ? "0 6px" : 0,
        gap: "30px",
      }}
    >
      <div
        style={{
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "14px" : "20px",
          textAlign: "center",
          color: "#737373",
        }}
      >
        {currentPage.question}
      </div>
      {currentPage.type === "example_blank" && (
        <div
          style={{
            fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "20px" : "28px",
            textAlign: "center",
          }}
        >
          {currentPage.text1}
        </div>
      )}
      <div
        style={{
          fontSize: Math.min(window.innerWidth, window.screen.width) <= 768 ? "20px" : "28px",
          textAlign: "center",
        }}
      >
        {currentPage.text}
      </div>
      <div style={{ position: "relative", width: Math.min(window.innerWidth, window.screen.width) <= 768 ? "100%" : "60%", marginTop: Math.min(window.innerWidth, window.screen.width) <= 768 ? "24px" : "50px" }}>
        <UserInputBar
          handleChange={handleChange}
          userInput={userInput}
          type="vocabulary"
          disabled={currentPage.isSubmitted}
          handleSetAnswer={handleSubmit}
        />
      </div>
    </div>
  );
};

export default SubjectiveExamPage;
